import { toast } from "react-toastify";

import { publicRequest } from "../api/apiLink";
import { getCreateUser } from "./publicHotspotApi/publicSlice";
const apiKey =
  "021b3d466696fc6044786ed6858a8e731051c83d4054a5f038e5e1eba42c323188374f1d05d852287462b5e67587bd91218f297ff71f088811778ea79a71677f";

export const getIspOwner = async (ispId, setIsLoading, setIspInfo) => {
  setIsLoading(true);
  try {
    const { data } = await publicRequest.get(`isp?netFeeId=${ispId}`, {
      headers: {
        apiKey,
      },
    });
    setIspInfo(data);
  } catch (error) {
    toast.error("Invalid ISP");
    console.log(error);
  }
  setIsLoading(false);
};

export const getCustomerInfo = async (
  ispOwnerId,
  setIsLoading,
  setCustomerInfo,
  input
) => {
  setIsLoading(true);

  try {
    const { data } = await publicRequest.get(
      `isp/customer/${ispOwnerId}?customerId=${input}`,
      {
        headers: {
          apiKey,
        },
      }
    );

    setCustomerInfo(data);
  } catch (error) {
    toast.error(error.response?.data?.message);

    console.log(error);
  }

  setIsLoading(false);
};

export const getHotspotUser = async (
  dispatch,
  ispId,
  username,
  password,
  setIsLoading
) => {
  setIsLoading(true);
  try {
    const res = await publicRequest.get(
      `isp/hotspot/customer?netFeeId=${ispId}&username=${username}&password=${password}`,
      {
        headers: {
          apiKey,
        },
      }
    );

    dispatch(getCreateUser(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getHotspotUserConnect = async (
  customerId,
  mikrotik,
  setIsLoading
) => {
  setIsLoading(true);
  try {
    const res = await publicRequest.get(
      `isp/hotspot/connect/${customerId}?mikrotik=${mikrotik}`,
      {
        headers: {
          apiKey,
        },
      }
    );
    setIsLoading(false);

    window.location.href = `http://wifi.login/login?username=${res.data?.data.hotspot.name}&password=${res.data?.data.hotspot.password}`;
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};
